/**
 * @voltxampere/ui — LM4040-10.0 voltage reference variant (Sprint 42-3)
 *
 * Reference: TI LM4040-10.0. Fixed 10.000 V shunt voltage reference,
 * ±0.2 %, SOT-23.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const referenceLm4040_10v = {
    id: "lm4040-10v",
    nameTr: "LM4040-10.0 (Hassas Referans 10V, SOT-23)",
    nameEn: "LM4040-10.0 (Precision Reference 10V, SOT-23)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "LM4040-10.0",
    schemaType: "voltage-source",
    defaultParams: { voltage: 10 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=reference-lm4040-10v.js.map